import React from 'react';
import { Inline, Radio, Stack, Text } from '@treatwell/ui';
import { ConditionalWrapper } from 'js/components/Utilities/ConditionalWrapper';
import styles from './RadioGroupFilter.module.css';

export type RadioOption<T = string> = {
  label: string;
  value: T;
  description?: string;
};

export const RadioGroupFilter = <T extends string>({
  name,
  options,
  onSelect,
  selected,
}: {
  name: string;
  selected?: T;
  options: RadioOption<T>[];
  onSelect: (value: T) => void;
}) => {
  const composeHandleSelect = (value: T) => () => onSelect(value);

  return (
    <Stack as="ul" space="md" data-cy="filter-sort">
      {options.map((option) => (
        <li key={option.value}>
          <Inline justify="between">
            <ConditionalWrapper
              condition={option.description !== undefined}
              render={(children) => <Stack space="xxs">{children}</Stack>}
            >
              <Text as="label" type="caption" htmlFor={option.value}>
                {option.label}
              </Text>
              {option.description && (
                <Text type="footnote" className={styles.footnote}>
                  {option.description}
                </Text>
              )}
            </ConditionalWrapper>
            <Radio
              id={option.value}
              name={name}
              value={option.value}
              checked={option.value === selected}
              onChange={composeHandleSelect(option.value)}
            />
          </Inline>
        </li>
      ))}
    </Stack>
  );
};
